import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import { Label, Input, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.proyectos.config.plan.subtipos.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"El Subtipo de Transferencia ha sido creado con éxito."}
                title={"Nuevo Subtipo de Transferencia"}
                buttonTitle={"Nuevo Subtipo de Transferencia"}
                buttonIcon={"fa fa-plus fa-lg"}
                
                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}>
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos del subtipo</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" autoFocus data-auto-focus="true"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Tipo</Label>
                                <ParadigmaAsyncSeeker fieldName={"tipo_id"} url={api.proyectos.config.plan.tipos.select} />
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_SubTipos/Create.js